import {Hub} from 'yougile-model'
import {Column} from '@extensions/column'

interface Props {
  dragAllowed: boolean
  hub: Hub
  report?: boolean
  mirror?: boolean
  type: string
}

export const canDrag = (props: Props): boolean => {
  const {hub, type, report, mirror, dragAllowed} = props

  // нельзя драгать задачи в сводках
  if (report && type === 'task') {
    return false
  }

  // нельзя драгать колонки внутри колонки зеркало
  if (mirror && type === 'column' && !Column.isMirror(hub)) {
    return false
  }

  return dragAllowed
}

interface ChangeDeadlineProps {
  dragAllowed: boolean
  type: string
}

export const canChangeDeadline = (props: ChangeDeadlineProps): boolean => {
  const {type, dragAllowed} = props
  if (type === 'column') {
    return false
  }

  return dragAllowed
}
